const serviceDetailsData = {
    // "Banking Services": [
    //     {
    //         heading: "AePS",
    //         desc: "Help customers withdraw DBT, government relief funds and cash from their bank accounts using fingerprint with Aadhaar enabled Payment Services (AePS)",
    //     },
    //     {
    //         heading: "Micro ATM",
    //         desc: "Provide cash withdrawal services using debit cards of over 1000+ banks",
    //     },
    //     {
    //         heading: "Money Transfer",
    //         desc: "Take advantage of our time tested platform with 99.9% success rate to help customers send money from anywhere to anywhere within India, real time, 24*7. Customers use this service also to deposit cash into their accounts",
    //     },
    // ],

    // "Digital Suite": [
    //     {
    //         heading: "Mobile POS",
    //         desc: "Use Micro ATM as a point-of-sale (PoS) device and accept debit/credit card payments from customers",
    //     },
    //     {
    //         heading: "Customer Khata",
    //         desc: "Upgrade your business with 100% better customer credit management. A digital ledger that maintains record of all transactions, sets automatic payment reminders and helps you collect payments through integrated digital payment solutions",
    //     },
    //     {
    //         heading: "UPI QR",
    //         desc: "A single QR Code that helps you accept payment from any payment app. Make it your mobile screen saver or print and dispaly on the shop to enable seamless digital payments",
    //     },
    //     {
    //         heading: "Aadhaar Pay",
    //         desc: "Accept payments from customers using Aadhaar biometric",
    //     },


    // ],
    "Insurance": [
        {
            heading: "General",
            desc: "We offer a range of affordable general insurance plans, including bike insurance and mobile device protection plans",
        },
    ],

    "Travel": [
        {
            heading: "Flight Booking",
            desc: "An IATA accredited platform for booking flight tickets at competitive rates and great commissions.",
        },

        {
            heading: "Bus Booking",
            desc: "An IATA accredited platform for booking bus tickets at competitive rates and great commissions.",
        },
    ],

    // "Utility Bill Payment Centre": [
    //     {
    //         heading: "Gas, Electricity & Water Bills",
    //         desc: "Every household needs to pay these utility bills every month. Offer them from your shop and ensure regular monthly income for yourself",
    //     },

    //     {
    //         heading: "Recharge Services",
    //         desc: "Offer customers the options to recharge mobile, DTH services and data cards from 15+ partners. Recharge transactions are frequent in nature and will ensure recurring income",
    //     },
    //     {
    //         heading: "Credit Card Payments",
    //         desc: "Help customers make their credit card payments across 25+ banks. Credit card payment also follows a monthly cycle, and will ensure recurring income opportunity for yourself"
    //     },

    //     {
    //         heading: "LIC Premium Payments",
    //         desc: "Help customers pay their LIC premiums monthly, quarterly, half-yearly or annually and ensure a recurring income for yourself"
    //     },
    // ],
    // "Credit Services": [
    //     {
    //         heading: "Gold Loan",
    //         desc: "Quick, secure gold loans with minimum documentation for you and your customers.",
    //     },

    //     {
    //         heading: "Business Loan",
    //         desc: "Easy, unsecured business loans for retailers at affordable rates to ensure business growth",
    //     },
    //     {
    //         heading: "Personal Loan",
    //         desc: "An instant solution for all financial needs. Avail quick and affordable personal loans for all life goals, including medical emergencies, weddings, or to fund children’s education."

    //     },

    // ],
};

export default serviceDetailsData;
